
import '../App.css';
import '../Css/Contact.css';
import FomrContact from "./FormContact.js";
import ContactTiles from "./ContactTiles.js";

export default function Contact() {


  return (
    <>
    <ContactTiles></ContactTiles>
    <FomrContact></FomrContact>
    </>
    
    
  );
}